import { render, staticRenderFns } from "./InpatientReviewMassUpdate.vue?vue&type=template&id=60939827&"
import script from "./InpatientReviewMassUpdate.vue?vue&type=script&lang=js&"
export * from "./InpatientReviewMassUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports